import Repository from "@/repositories/Repository";
import TokenService from "@/helpers/token";

const resource = `${Repository.defaults.baseURL}/log`

export default {
    async saveLogOds(body) {
        const response = await Repository.post(`${resource}/register-ods`, body, {
            headers: TokenService.getHeader()
        })
        return response
    }
}